import React from "react";

export const questionBlobOutline = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <path
        fill="currentColor"
        d="M12 2C6.473 2 2 6.473 2 12v9.219c0 .431.35.781.781.781H12c5.527 0 10-4.472 10-10S17.528 2 12 2m0 18.438H3.563V12A8.433 8.433 0 0 1 12 3.563 8.433 8.433 0 0 1 20.438 12 8.433 8.433 0 0 1 12 20.438"
      />
      <path
        fill="currentColor"
        d="M12.04 8q1.405 0 2.253.744.848.73.848 2.086 0 1.26-.822 1.966-.652.558-1.651.674c-.273.031-.495.25-.495.525a.5.5 0 0 1-.5.501h-.56a1.06 1.06 0 0 1-1.06-1.06v-.616c0-.439.356-.795.795-.795q1.034 0 1.564-.252.53-.266.53-.943 0-.452-.265-.704-.252-.267-.69-.266-.476 0-.741.279c-.301.318-.607.73-1.044.73H9.91c-.585 0-1.092-.479-.905-1.033q.075-.221.187-.428a2.57 2.57 0 0 1 1.1-1.023Q11.021 8 12.041 8m-.864 7.532a1.156 1.156 0 1 1 0 2.312h-.033a1.156 1.156 0 0 1 0-2.312z"
      />
    </svg>
  );
};
